import { useState } from "react";
import { ExpandDropDownList } from "@/utils/icons";
import classNames from "classnames";
import { Collapse } from "antd";
import s from './index.module.css';

export const CollapsePanel = ({children, header='', className=''}) => {

    const [activePanels, setActivePanels] = useState([]);
    const customExpandIcon = ({ isActive }) => (
        isActive ? 
        <ExpandDropDownList className={classNames(s.customExpandIcon, s.rotate)} /> : 
        <ExpandDropDownList className={s.customExpandIcon} />
    );
    
    return (
        <Collapse 
            activeKey={activePanels}
            onChange={(keys) => setActivePanels(keys)}
            expandIconPosition="end"
            className={classNames(s.collapse, {[className]: !!className})}
            expandIcon={customExpandIcon}
            >
                <Collapse.Panel
                        key={1}
                        header={header}
                >
                      {
                        children
                      }
                </Collapse.Panel>
        </Collapse>
    )
}
